/**
 * DragOverlayCard — the floating card while dragging.
 *
 * Per FWV v8 §30: rendering extracted from TodayView.
 * Visual treatment: translucent gradient, soft shadow, slight tilt so the user
 * sees they're moving something. The "+N more" badge shows when the dragged
 * card is part of a multi-selection.
 */
import { Sparkles } from 'lucide-react'
import type { DbTask } from '../../db'

export function DragOverlayCard({
  task,
  multiCount,
}: {
  task: DbTask
  multiCount: number
}) {
  return (
    <div
      className="kanban-card rounded-xl p-3 border-2 border-garden-600 max-w-xs pointer-events-none"
      style={{
        background: 'linear-gradient(180deg, rgba(255,255,255,0.96), rgba(240,253,244,0.96))',
        backdropFilter: 'blur(6px)',
        boxShadow:
          '0 20px 25px -5px rgb(0 0 0 / 0.18), 0 8px 10px -6px rgb(0 0 0 / 0.12), 0 0 0 1px rgba(109,40,217,0.15)',
        transform: 'rotate(-1.5deg) scale(1.04)',
        opacity: 0.95,
      }}
    >
      <h3 className="text-sm font-medium text-skin-text">{task.title}</h3>
      <div className="mt-1 flex items-center gap-2">
        {multiCount > 1 && (
          <span className="text-xs font-medium text-garden-700 bg-garden-100 rounded-full px-2 py-0.5">
            +{multiCount - 1} more
          </span>
        )}
        <span className="text-xs text-slate-500 flex items-center gap-1">
          <Sparkles className="w-3 h-3 text-reward-500" /> {task.ep} EP
        </span>
      </div>
    </div>
  )
}